import { render, staticRenderFns } from "./InsuranceCardUpdatedList.vue?vue&type=template&id=3e6a240f&scoped=true&"
import script from "./InsuranceCardUpdatedList.vue?vue&type=script&lang=js&"
export * from "./InsuranceCardUpdatedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6a240f",
  null
  
)

export default component.exports